/**
 * Centre Page team profiles — Read more / Read less bio toggle.
 *
 * Expanding or collapsing one card syncs all bios in the team section.
 */
(function () {
	'use strict';

	/**
	 * Set expanded state on a single bio card.
	 *
	 * @param {Element} bio     Bio wrapper element.
	 * @param {boolean} expand  Whether to expand.
	 * @param {string}  readMore Read more label.
	 * @param {string}  readLess Read less label.
	 */
	function setBioExpanded(bio, expand, readMore, readLess) {
		var button = bio.querySelector('.bio-toggle');

		if (expand) {
			bio.classList.add('is-expanded');
		} else {
			bio.classList.remove('is-expanded');
		}

		if (!button || button.hidden) {
			return;
		}

		button.setAttribute('aria-expanded', expand ? 'true' : 'false');
		button.textContent = expand ? readLess : readMore;
	}

	/**
	 * Toggle all bios in the team section to match the clicked card's new state.
	 *
	 * @param {Element} button Clicked toggle button.
	 */
	function toggleBio(button) {
		var bio = button.closest('.profile-card-bio');
		if (!bio) {
			return;
		}

		var section = button.closest('.centre-team-section');
		if (!section) {
			return;
		}

		var labels = window.guardianCentrePageTeam || {};
		var readMore = labels.readMore || 'Read more';
		var readLess = labels.readLess || 'Read less';
		var expand = !bio.classList.contains('is-expanded');

		section.querySelectorAll('.profile-card-bio').forEach(function (cardBio) {
			setBioExpanded(cardBio, expand, readMore, readLess);
		});
	}

	function init() {
		document.querySelectorAll('.profile-card-bio .bio-toggle').forEach(function (button) {
			var bio = button.closest('.profile-card-bio');
			var visible = bio ? bio.querySelector('.bio-visible') : null;
			if (!visible || visible.scrollHeight <= visible.clientHeight + 1) {
				button.hidden = true;
			}

			button.addEventListener('click', function () {
				toggleBio(button);
			});
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
